module.exports = __webpack_public_path__ + "img/schmiedegitter.6b7cb2ef.webp";